import { Snackbar, SnackbarProps } from '@mui/material';

const anchorOrigin = { vertical: 'top', horizontal: 'center' } as const;
export default function BaseSnackbar(props: SnackbarProps) {
  return <Snackbar sx={{ whiteSpace: 'break-spaces' }} anchorOrigin={anchorOrigin} {...props} />;
}
